import { State } from "."

export const clearAll = (states: State<any>[]) => {
    states.forEach((state: State<any>) => {
        state.clear();
    });
}

export const saveAll = (states: State<any>[]) => {
    states.forEach((state: State<any>) => {
        state.save();
    });
}